/* Next */
import Link from 'src/components/Link'

/* Material */
import Table from '@mui/material/Table'
import Body from '@mui/material/TableBody'
import Cell from '@mui/material/TableCell'
import Container from '@mui/material/TableContainer'
import Head from '@mui/material/TableHead'
import Row from '@mui/material/TableRow'
import Paper from '@mui/material/Paper'
import useStyles from './styles'

/* Types */
import { tProduct } from 'src/shared/frontendTypes/product'

/* Functions */
import productUrl from 'src/functions/productUrl'

interface Props { product:tProduct }

/* ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++ */

const Modelle = ({
  product:{ id, path, combinations }
}: Props) => {
  const classes = useStyles()

  return <Container component={Paper}>
    <Table 
      aria-label="Produktausführungen" 
      sx={{ '& td, & th': { whiteSpace: 'nowrap' } }} 
      className={classes.modelTable}
    >
      <Head>
        <Row>
          <Cell>Modell</Cell>
          <Cell>Artikel-Nr.</Cell>
          <Cell>EAN</Cell>
          <Cell>SKU</Cell>
          <Cell>MPN</Cell>
          <Cell align='right'>Am Lager</Cell>
        </Row>
      </Head>
      <Body>
        {combinations.map(combination=>{
          const { key, options, attributes, ean, sku, mpn, stock } = combination
          return <Row
            key={key}
            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
          > 

            <Cell>
              <Link href={productUrl(id,path,options)} legacyBehavior>
                <a 
                  onClick={()=>window.scrollTo(0,0) /* TODO: Richtige Herader-Höhe */}
                >
                  {attributes.length > 0
                    ? attributes.join(', ')
                    : "Standard"
                  }
                </a>
              </Link>
            </Cell>

            <Cell>{key}</Cell>
            <Cell>{ean}</Cell>
            <Cell>{sku}</Cell>
            <Cell>{mpn}</Cell>
            <Cell align='right'>{stock}</Cell>
          </Row>
        })}
      </Body>
    </Table>
  </Container>
}

export default Modelle
